// app/javascript/controllers/search_controller.js
// COMPLETE FIX: All 3 issues resolved
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "results", "count", "loading", "filterSidebar", "filterForm", "listViewContainer", "mapViewContainer", "listViewButton", "mapViewButton", "resultsGrid", "loadMoreButton"]
  static values = {
    debounceDelay: { type: Number, default: 300 },
    mapScriptUrl: { type: String, default: '' }
  }

  connect() {
    this.timeout = null
    console.log("Search controller connected")
    console.log("Controller element:", this.element)
    console.log("Controller element ID:", this.element.id)
    console.log("Targets found:", {
      listViewContainer: this.hasListViewContainerTarget,
      mapViewContainer: this.hasMapViewContainerTarget,
      listViewButton: this.hasListViewButtonTarget,
      mapViewButton: this.hasMapViewButtonTarget
    })
    console.log("Searching for targets in DOM...")
    const allSearchTargets = this.element.querySelectorAll('[data-search-target]')
    console.log("Found", allSearchTargets.length, "elements with data-search-target within controller")
    allSearchTargets.forEach(el => {
      console.log("  -", el.getAttribute('data-search-target'), el.tagName, el.id || '(no id)')
    })

    // Check URL for view parameter
    const urlParams = new URLSearchParams(window.location.search)
    const view = urlParams.get('view')

    if (view === 'map' && this.hasMapViewContainerTarget && this.hasMapViewButtonTarget) {
      // Switch to map view on load
      setTimeout(() => {
        console.log("Switching to map view from URL parameter")
        this.activateMapView()
      }, 500)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  // Live search with debouncing
  autocomplete(event) {
    // Show loading immediately so typing feels responsive
    this.showLoading()

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.performLiveSearch()
    }, this.debounceDelayValue)
  }

  // Perform live search via AJAX
  performLiveSearch() {
    const form = this.formTarget
    const formData = new FormData(form)
    const params = new URLSearchParams(formData)

    // Minimum character requirement: silently skip 1-2 character queries
    const query = params.get('q') || ''
    if (query.length > 0 && query.length < 3) {
      console.log('Query too short (< 3 chars), skipping search')
      return
    }

    // Show loading state
    this.showLoading()

    // Make AJAX request
    fetch(`${form.action}?${params.toString()}`, {
      headers: {
        'Accept': 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(script => {
      // Execute the returned JavaScript
      eval(script)
      this.hideLoading()

      // If map view is active, reload branch map with new search query
      const mapViewContainer = this.hasMapViewContainerTarget ?
        this.mapViewContainerTarget :
        document.getElementById('branch-map-view')

      if (mapViewContainer && !mapViewContainer.classList.contains('hidden')) {
        setTimeout(() => {
          if (typeof window.reloadBranchMap === 'function') {
            window.reloadBranchMap()
          }
        }, 200)
      }
    })
    .catch(error => {
      console.error('Live search error:', error)
      this.hideLoading()
    })
  }

  // Submit the search form via AJAX
  submit(event) {
    if (event) {
      event.preventDefault()
    }

    const form = this.formTarget
    const formData = new FormData(form)
    const params = new URLSearchParams(formData)

    // Show loading state
    this.showLoading()

    // Make AJAX request
    fetch(`${form.action}?${params.toString()}`, {
      headers: {
        'Accept': 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(script => {
      // Execute the returned JavaScript
      eval(script)
      this.hideLoading()

      // If map view is active, reload branch map with new filters
      const mapViewContainer = this.hasMapViewContainerTarget ?
        this.mapViewContainerTarget :
        document.getElementById('branch-map-view')

      console.log("Checking if map view is active:", {
        containerFound: !!mapViewContainer,
        isHidden: mapViewContainer?.classList.contains('hidden')
      })

      if (mapViewContainer && !mapViewContainer.classList.contains('hidden')) {
        console.log("Map view is active, reloading branch map with new filters")
        setTimeout(() => {
          if (typeof window.reloadBranchMap === 'function') {
            window.reloadBranchMap()
          } else {
            console.error("window.reloadBranchMap function not found!")
          }
        }, 200)
      }
    })
    .catch(error => {
      console.error('Search error:', error)
      this.hideLoading()
    })
  }

  // Load the next page of results and append them to the existing grid.
  // Triggered by the "Mehr laden" button rendered by _load_more_button.html.erb.
  loadMore(event) {
    if (event) event.preventDefault()

    const button = event.currentTarget
    const nextPage = button?.dataset?.nextPage
    if (!nextPage) return

    const form = this.formTarget
    const formData = new FormData(form)
    const params = new URLSearchParams(formData)
    params.set('page', nextPage)

    // Inline button loading state — the existing grid stays visible, no overlay.
    const originalLabel = button.textContent
    button.disabled = true
    button.textContent = 'Lädt…'

    fetch(`${form.action}?${params.toString()}`, {
      headers: {
        'Accept': 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(script => {
      eval(script)
    })
    .catch(error => {
      console.error('Load more error:', error)
      button.disabled = false
      button.textContent = originalLabel
    })
  }

  // Clear search input
  clear(event) {
    event.preventDefault()
    
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
      this.submit()
    }
  }

  // Toggle mobile filter sidebar
  toggleMobileFilters(event) {
    event.preventDefault()
    
    if (this.hasFilterSidebarTarget) {
      this.filterSidebarTarget.classList.toggle('hidden')
      this.filterSidebarTarget.classList.toggle('block')
    }
  }

  // FIX #2: Show list view
  showListView(event) {
    event.preventDefault()
    console.log("Switching to list view")
    this.activateListView()
  }

  // FIX #2: Show map view
  showMapView(event) {
    event.preventDefault()
    console.log("==== MAP BUTTON CLICKED ====")
    console.log("Event:", event)
    console.log("Has targets:", {
      listViewContainer: this.hasListViewContainerTarget,
      mapViewContainer: this.hasMapViewContainerTarget
    })
    this.activateMapView()
  }

  // Activate list view (can be called internally or from button)
  activateListView() {
    console.log("activateListView called")

    // Get containers using getElementById as most reliable fallback
    const listViewContainer = this.hasListViewContainerTarget ?
      this.listViewContainerTarget :
      document.getElementById('branch-list-view')

    const mapViewContainer = this.hasMapViewContainerTarget ?
      this.mapViewContainerTarget :
      document.getElementById('branch-map-view')

    console.log("Container elements found:", {
      listView: !!listViewContainer,
      mapView: !!mapViewContainer,
      listViewId: listViewContainer?.id,
      mapViewId: mapViewContainer?.id
    })

    if (!listViewContainer || !mapViewContainer) {
      console.error("Cannot find view containers even with fallback queries")
      console.error("Tried: #branch-list-view and #branch-map-view")
      return
    }

    // Show list, hide map
    listViewContainer.classList.remove('hidden')
    mapViewContainer.classList.add('hidden')

    // Get buttons using direct DOM queries as fallback
    const listBtn = this.hasListViewButtonTarget ?
      this.listViewButtonTarget :
      this.element.querySelector('[data-search-target="listViewButton"]')

    const mapBtn = this.hasMapViewButtonTarget ?
      this.mapViewButtonTarget :
      this.element.querySelector('[data-search-target="mapViewButton"]')

    // Update button styles - List button active (orange), Map button inactive
    if (listBtn) {
      listBtn.classList.remove('text-gray-700', 'hover:bg-gray-50')
      listBtn.classList.add('bg-orange-500', 'text-white')
    }

    if (mapBtn) {
      mapBtn.classList.remove('bg-orange-500', 'text-white')
      mapBtn.classList.add('text-gray-700', 'hover:bg-gray-50')
    }

    // Update URL
    this.updateViewInUrl(null)

    console.log("List view activated")
  }

  // Activate map view (can be called internally or from button)
  activateMapView() {
    console.log("activateMapView called")

    // Get containers using getElementById as most reliable fallback
    const listViewContainer = this.hasListViewContainerTarget ?
      this.listViewContainerTarget :
      document.getElementById('branch-list-view')

    const mapViewContainer = this.hasMapViewContainerTarget ?
      this.mapViewContainerTarget :
      document.getElementById('branch-map-view')

    console.log("Container elements found:", {
      listView: !!listViewContainer,
      mapView: !!mapViewContainer,
      listViewId: listViewContainer?.id,
      mapViewId: mapViewContainer?.id
    })

    if (!listViewContainer || !mapViewContainer) {
      console.error("Cannot find view containers even with fallback queries")
      console.error("Tried: #branch-list-view and #branch-map-view")
      return
    }

    // Hide list, show map
    listViewContainer.classList.add('hidden')
    mapViewContainer.classList.remove('hidden')

    // Get buttons using direct DOM queries as fallback
    const listBtn = this.hasListViewButtonTarget ?
      this.listViewButtonTarget :
      this.element.querySelector('[data-search-target="listViewButton"]')

    const mapBtn = this.hasMapViewButtonTarget ?
      this.mapViewButtonTarget :
      this.element.querySelector('[data-search-target="mapViewButton"]')

    // Update button styles - Map button active (orange), List button inactive
    if (mapBtn) {
      mapBtn.classList.remove('text-gray-700', 'hover:bg-gray-50')
      mapBtn.classList.add('bg-orange-500', 'text-white')
    }

    if (listBtn) {
      listBtn.classList.remove('bg-orange-500', 'text-white')
      listBtn.classList.add('text-gray-700', 'hover:bg-gray-50')
    }

    // Update URL
    this.updateViewInUrl('map')

    // If map already initialized, trigger resize so tiles re-render after container was hidden.
    // Double rAF + 250ms timeout gives iOS Safari time to commit the layout reflow
    // after un-hiding the parent container before we ask Google Maps to repaint.
    if (window.branchMapData && window.branchMapData.map && typeof google !== 'undefined' && google.maps) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        setTimeout(() => {
          google.maps.event.trigger(window.branchMapData.map, 'resize')
        }, 250)
      }))
    }

    // Show loading spinner immediately
    this.showMapLoading()

    // SEMRUSH FIX: Lazy load map script to reduce initial HTML size
    this.loadMapScriptIfNeeded()

    console.log("Map view activated")
  }

  // Load the Google Maps SDK on demand.
  //
  // communities#index and communities#show no longer ship the Maps SDK,
  // markerclusterer and gmaps4rails in <head> (~125 KB plus main-thread parse
  // cost on every visit to our two busiest pages, and the homepage has no map
  // container in the markup at all). They are fetched here instead, the first
  // time someone actually switches to map view. Pages that paint a map during
  // the initial render still get the eager <head> tags: see the `eager_map`
  // block in layouts/main.html.erb.
  //
  // The promise is memoised on window because two controller instances can
  // race, and cleared on failure so a flaky network can be retried.
  ensureGoogleMaps() {
    if (window.google && window.google.maps) return Promise.resolve()
    if (window.googleMapsSdkLoader) return window.googleMapsSdkLoader

    const key = document.querySelector('meta[name="google-maps-api-key"]')?.content
    if (!key) {
      // Eager pages never reach here (google.maps is already defined); a lazy
      // page without the meta tag is a layout bug, so say so rather than hang.
      return Promise.reject(new Error('google-maps-api-key meta tag is missing'))
    }

    const loadScript = (src) => new Promise((resolve, reject) => {
      const el = document.createElement('script')
      el.src = src
      el.async = true
      el.onload = resolve
      el.onerror = () => reject(new Error(`Failed to load ${src}`))
      document.head.appendChild(el)
    })

    // Maps first: both helpers below reference google.maps as they initialise.
    window.googleMapsSdkLoader = loadScript(`https://maps.google.com/maps/api/js?key=${encodeURIComponent(key)}`)
      .then(() => Promise.all([
        loadScript('/vendor/markerclusterer-1.0.0.min.js'),
        loadScript('/vendor/gmaps4rails-2.1.2.min.js')
      ]))
      .catch((error) => {
        window.googleMapsSdkLoader = null
        throw error
      })

    return window.googleMapsSdkLoader
  }

  // Lazy load the map script only when needed (first time map view is shown)
  loadMapScriptIfNeeded() {
    // If Turbo navigated to a new page, the previous map's DOM element is detached.
    // The script is stale (bakes community slug/coords into closures at injection time),
    // so reset all cached state to force a fresh fetch for the current page.
    const prevMapDiv = window.branchMapData?.map?.getDiv?.()
    if (prevMapDiv && !prevMapDiv.isConnected) {
      window.branchMapScriptLoaded = false
      window.branchMapInitialized = false
      window.branchMapData = null
      window.branchMapClustererRetries = 0
    }

    // Check if script is already loaded
    if (window.branchMapScriptLoaded) {
      console.log("Map script already loaded, initializing...")
      this.initializeBranchMapWithRetry()
      return
    }

    console.log("Lazy loading map script for first time...")

    // Use explicit URL from data attribute (required - avoids fragile URL parsing)
    const scriptUrl = this.mapScriptUrlValue
    if (!scriptUrl) {
      console.error("Map script URL not set - add data-search-map-script-url-value to the controller element")
      return
    }

    this.ensureGoogleMaps()
    .then(() => fetch(scriptUrl, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }))
    .then(response => response.text())
    .then(html => {
      console.log("Map script loaded, injecting into page...")

      // Find the first inline <script> with actual content, skipping external scripts
      // (Rack::MiniProfiler injects a <script src="..."> before the partial in staging/prod)
      const scriptContent = [...html.matchAll(/<script(?:\s[^>]*)?>([^]*?)<\/script>/gi)]
        .map(m => m[1].trim())
        .find(content => content.length > 0)

      if (!scriptContent) {
        console.error("No script tag found in map script response")
        this.hideMapLoading()
        return
      }

      // Inject script via textContent — executes synchronously, works in all browsers.
      const newScript = document.createElement('script')
      newScript.textContent = scriptContent
      document.body.appendChild(newScript)
      console.log("Map script injected and executed")
      window.branchMapScriptLoaded = true
      this.initializeBranchMapWithRetry()
    })
    .catch(error => {
      console.error("Failed to load map script:", error)
      this.hideMapLoading()

      // Show error in loading container
      const loadingEl = document.getElementById('branch-map-loading')
      if (loadingEl) {
        loadingEl.innerHTML = `
          <svg class="w-12 h-12 text-red-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-sm text-red-600 font-medium mb-2">Failed to load map</p>
          <button onclick="location.reload()" class="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors text-sm">
            Refresh Page
          </button>
        `
        loadingEl.style.display = 'flex'
      }
    })
  }

  // Show map loading indicator
  showMapLoading() {
    const loadingEl = document.getElementById('branch-map-loading')
    if (loadingEl) {
      loadingEl.style.display = 'flex'
    }
  }

  // Hide map loading indicator
  hideMapLoading() {
    const loadingEl = document.getElementById('branch-map-loading')
    if (loadingEl) {
      loadingEl.style.display = 'none'
    }
  }

  // Initialize branch map with retry mechanism to wait for script to load
  initializeBranchMapWithRetry(attempt = 1, maxAttempts = 30, delay = 150) {
    console.log(`Attempting to initialize branch map (attempt ${attempt}/${maxAttempts})...`)

    if (typeof window.initializeBranchMap === 'function') {
      console.log("Branch map function found, initializing...")
      window.initializeBranchMap()
      // Note: loadBranchMapData() will hide the loading indicator when done
    } else if (attempt < maxAttempts) {
      console.log(`Branch map function not ready yet, retrying in ${delay}ms...`)
      setTimeout(() => {
        this.initializeBranchMapWithRetry(attempt + 1, maxAttempts, delay)
      }, delay)
    } else {
      console.error("window.initializeBranchMap function not found after all retries!")
      this.hideMapLoading()
      // Show error message in the loading container
      const loadingEl = document.getElementById('branch-map-loading')
      if (loadingEl) {
        loadingEl.innerHTML = `
          <svg class="w-12 h-12 text-red-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-sm text-red-600 font-medium mb-2">Map failed to load</p>
          <button onclick="location.reload()" class="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors text-sm">
            Refresh Page
          </button>
        `
        loadingEl.style.display = 'flex'
      }
    }
  }

  // Update URL to reflect current view
  updateViewInUrl(view) {
    const url = new URL(window.location)
    if (view === 'map') {
      url.searchParams.set('view', 'map')
    } else {
      url.searchParams.delete('view')
    }
    window.history.replaceState({}, '', url)
  }

  // Show loading state
  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('hidden')
    }
    if (this.hasResultsGridTarget) {
      this.resultsGridTarget.classList.add('opacity-30', 'pointer-events-none')
    }
  }

  // Hide loading state
  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('hidden')
    }
    if (this.hasResultsGridTarget) {
      this.resultsGridTarget.classList.remove('opacity-30', 'pointer-events-none')
    }
  }
}
